// extracted by mini-css-extract-plugin
export default {"h1":"Cart_h1__OGlDN","h11":"Cart_h11__s63xJ","blue":"Cart_blue__KN-Vd","h21":"Cart_h21__St7s7","span":"Cart_span__sAnvx","h31":"Cart_h31__Nv4Mt"};